var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{attrs:{"border":"left","type":"error"}},[_vm._t("default",function(){return [_vm._v("Dieser Bereich befindet sich noch im Aufbau und funktioniert noch nicht.")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }